<template>
  <layout-component>
    <div class="banner banner-dashboard">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-2">
            <h1 class="left-bullet" v-html="$t('title-banner')"></h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container container-giftcard form pb-4">
      <div class="row">
        <div class="col-md-8 offset-md-2">
          <div class="row">
            <div class="col-sm current-balance">
              <p>{{'title'|t}}:</p>
              <span class="current-balance">{{ $store.user.balance }}&euro;</span>
            </div>
          </div>

          <div class="row py-3">
            <div class="col-sm reedem-wrap">
              <h2>{{'reedem-title'|t}}:</h2>
              <form autocomplete="off" @submit.prevent="reedem" v-if="user" method="post" class="row">

                <div class="form-group col" :class="{ 'has-error': has_error }">
                    <label for="card-code">{{'label-card-code'|t}}</label>
                    <div class="input-wrapper">
                      <b-form-input type="text" id="card-code" v-model="giftcardCode" placeholder="redeemcode"></b-form-input>
                      <span class="focus-border"></span>
                    </div>
                    <small class="form-text text-danger" v-if="has_error">{{error}}</small>
                </div>

                <div class="form-group col">
                    <b-button type="submit" class="apply" v-bind:disabled="giftcardCode === ''"><span>{{'reedem-btn'|t}}</span>
                    </b-button>
                </div>
              </form>
            </div>
          </div>

          <div class="row" v-if="giftcards.length">
            <div class="col-sm">
              <h2>{{'used-cards'|t}}:</h2>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Code</th>
                    <th scope="col">{{'used-date'|t}}</th>
                    <th scope="col">{{'used-amount'|t}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="giftcard in giftcards" :key="giftcard.id">
                    <td>{{ giftcard.code }}</td>
                    <td>{{ giftcard.used_at ? new Date(giftcard.used_at).toLocaleDateString() : 'Not used' }}</td>
                    <td>{{ giftcard.amount }}&euro;</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
	</layout-component>
</template>

<script>
  export default {
    data() {
      return {
        user: null,
        has_error: false,
        error: '',
        errors: {},
        giftcards: [],
        giftcardCode: '',
        success: false
      }
    },
    mounted() {
      this.user = this.$auth.user()
      this.getPreviousCards()
    },
    methods: {
      getPreviousCards() {
        Vue.axios.get('/giftcards/index')
        .then(res => {
          this.giftcards = res.data
        })
        .catch(error => {
          console.log(error)
        })
      },
      reedem() {
        this.hasError = false
        this.error = ''

        Vue.axios.post('/giftcards/redeem', {
            code: this.giftcardCode
        })
        .then(res => {
            this.success = true
            this.getPreviousCards()
            this.giftcardCode = ''
            this.$store.reloadUser()
        })
        .catch(error => {
            this.has_error = true
            this.error = error.response?.data?.message || 'Une erreur est survenue'
            this.success = false
            this.$store.reloadUser()
        })}
    }
  }
</script>

<i18n>
    {
      "en": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Gift cards</span></span>",
        "bookings": "Bookings",
        "profile": "Profile",
        "success-title-01": "Great news",
        "success-text-01": "Your profile has been updated.",
        "error-title-01": "Validation error",
        "error-text-01": "Please see below. ",
        "error-title-02": "Error.",
        "error-text-02": "Unable to update your profile for now. Please try again later or contact us.",
        "subtitle-01": "Edit your profile",
        "title-01": "Who you are",
        "title-02": "Your password",
        "title-03": "Where you work",
        "title-04": "Where you live",
        "text-password": "Please leave the fields blank unless you want to change your password",
        "label-card-code": "Card code",
        "submit-btn": "Save",
        "email-not-verified": "Please go to your mailbox to confirm your account",
        "email-resend": "Resend email",
        "title": "Current balance",
        "reedem-title": "Reedem card",
        "reedem-btn": "Reedem",
        "used-cards": "Used cards",
        "used-date": "Date of use",
        "used-amount": "Amount"
      },
      "fr": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Cartes cadeau</span></span>",
        "bookings": "Reservations",
        "profile": "Profil",
        "success-title-01": "Bonne nouvelle",
        "success-text-01": "Votre profil a été mis à jour.",
        "error-title-01": "Erreur de validation",
        "error-text-01": "Voir ci-dessous. ",
        "error-title-02": "Erreur.",
        "error-text-02": "La mise à jour de votre profil est impossible pour l’instant. Veuillez réessayer plus tard ou nous contacter.",
        "subtitle-01": "Modifier votre profil",
        "title-01": "Qui vous etes",
        "title-02": "Votre mot de passe",
        "title-03": "Ou vous travaillez",
        "title-04": "Ou vous habitez",
        "text-password": "Veuillez laisser ces champs vierges, sauf si vous souhaitez modifier votre mot de passe.",
        "label-card-code": "Code de votre carte",
        "submit-btn": "Enregistrer",
        "email-not-verified": "Veuillez consulter votre boite mail pour confirmer votre compte",
        "email-resend": "Renvoyer l'email",
        "title": "Solde actuel",
        "reedem-title": "Activer votre carte cadeau",
        "reedem-btn": "Activer",
        "used-cards": "Cartes utilisées",
        "used-date": "Date d'utilisation",
        "used-amount": "Montant"
      }
    }

  </i18n>
